<template>
  <keep-alive>
    <top-navbar :currentRoute="$route" :filter="false" :createBtn="true" :createBtnText="'Создать на основании'" @createElement="createElement" :createBtnDisable="disablecreateBtn"></top-navbar>
  </keep-alive>

  <transition name="fade">
    <section v-if="!isReady">
      <div class="container-loading">
        <span class="loader loader-default loader-dark"></span>
      </div>
    </section>
  </transition>

  <transition name="fade">
    <div class="full-height-block" v-if="isReady">
      <section class="container-content">

        <div class="accordion-block">
          <div class="accordion-block-item">
            <div class="accordion-block-header">
              <!-- Номер Заказа. При создании не заполняется. Заполняется при обмене с 1С из 1С -->
              <div class="container-acc-header">
                КП № {{ data.proposalNumber }}
              </div>
              <div class="container-acc-header">
                Дата предложения: 
                <span class="order-color-date">{{ data.validFrom }}</span>
              </div>
              <div class="container-acc-header">
                Актуально до: 
                <span class="order-color-date">{{ data.validTo }}</span>
              </div>
            </div>
            <!-- Блок для вывода уведомлений -->
            <div class="error-message" v-show="errorText != ''">
              <span>{{ errorText }}</span>
            </div>
            <div class="success-message" v-show="successText != ''">
              <span>{{ successText }}</span>
            </div>

            <!-- Блок с общими данными по Заказу.  
            Детальная информация по блоку в разделе 6.3.3.5 -->
            <div class="accordion-block-content">
              <div class="row">
                <div class="col-12 col-lg-6">
                  <div class="container-center">
                    <div class="group-label-input">
                      <label>Наименование проекта</label>
                      <input type="text" v-model="data.deal" readonly>
                    </div>
                  </div>
                </div>
                <div class="col-12 col-lg-6">
                  <div class="container-center">
                    <div class="group-label-input">
                      <label>Регион доставки</label>
                      <select v-model="selectedRegion">
                        <option value="">Выберите регион</option>
                        <option v-for="(region, index) in data.regions" :key="index" :value="region.id">
                          {{region.name}}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="col-12 col-lg-6">
                  <div class="container-center">
                    <div class="group-label-input">
                      <label>Тип продукции</label>
                      <select @click="getAddons = true" v-model="selectDivision">
                        <option value="">Все типы</option>
                        <option v-for="(type) in objectOrderDraft.division" :key="type" :value="type">{{type}}</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <accordion class="accordion-block" :openBlock="true" title="Товары">
          <table class="order-table">
            <tr>
              <th rowspan="2" class="pointer" style="width: 29px;" title="Выбрать все">
                <input 
                  type="checkbox" 
                  value="1"
                  v-model="addAllItems"
                  @click="selectAllItems()"
                >
              </th>
              <th rowspan="2">Наименование/Артикул</th>
              <th rowspan="2">Цена с НДС</th>
              <th colspan="4" class="text-center">Количество </th>
              <th rowspan="2">Общая сумма</th>
            </tr>
            <tr>
              <th>ед</th>
              <th>м2</th>
              <th>м3</th>
              <th>кг</th>
            </tr>
            <tr v-for="(item, index) in data.itemsList" :key="index" :value="item.id">
              <td>
                <input 
                type="checkbox" 
                :value="item.id"
                v-model="selectedItems"
                >
              </td>
              <td>
                <span class="tab-text-name">{{ item.name }}</span><br>
                <span class="tab-text-art">{{ item.sku }}</span>
              </td>
              <td>{{ formatNumber(item.price) }}</td>

              <td class="td-edit-field">
                <input v-if="showEditQuantity == item.id" class="quantity-field" type="number" v-model="item.quantity">
                <span v-else>{{item.quantity}}</span>
                <span v-if="showEditQuantity == item.id" class="td-edit-field-icon" @click="calculateQuantity(item)">
                  <mdicon name="check-bold" width="16" height="16" /> 
                </span>
                <span v-else class="td-edit-field-icon" @click="getEditQuantity(item.id)">
                  <mdicon name="pencil" width="16" height="16"/> 
                </span>
              </td>

              <td class="td-edit-field">
                <input v-if="showEditArea == item.id" class="quantity-field" type="number" v-model="item.area">
                <span v-else>{{ formatNumber(item.area) }}</span>
                <span v-if="showEditArea == item.id" class="td-edit-field-icon" @click="calculateArea(item)">
                  <mdicon name="check-bold" width="16" height="16" /> 
                </span>
                <span v-else class="td-edit-field-icon" @click="getEditArea(item.id)">
                  <mdicon name="pencil" width="16" height="16"/> 
                </span>
              </td>

              <td class="td-edit-field">
                <input v-if="showEditVolume == item.id" class="quantity-field" type="number" v-model="item.volume">
                <span v-else>{{ formatNumber(item.volume) }}</span>
                <span v-if="showEditVolume == item.id" class="td-edit-field-icon" @click="calculateVolume(item)">
                  <mdicon name="check-bold" width="16" height="16" /> 
                </span>
                <span v-else class="td-edit-field-icon" @click="getEditVolume(item.id)">
                  <mdicon name="pencil" width="16" height="16"/> 
                </span>
              </td>

              <td>{{ formatNumber(item.weight) }}</td>
              <td class="text-right">{{ formatNumber(getItogItemSumm(item)) }}</td>
            </tr>
            <tr>
              <th colspan="3">Итого</th>
              <th class="itog-cell">{{ itogQuantity }}</th>
              <th class="itog-cell">{{ formatNumber(itogArea) }}</th>
              <th class="itog-cell">{{ formatNumber(itogVolume) }}</th>
              <th>{{ formatNumber(itogWeight) }}</th>
              <th class="text-right">{{ formatNumber(itogSumm) }}</th>
            </tr>
          </table>
        </accordion>

        <button v-show="data.fileRef" class="btn btn-default small-btn ml-10 download-btn" type="submit" @click="downloadFile(data.fileRef)">
          Скачать PDF
          <mdicon name="download" width="17px"/>
        </button>

      </section>
    </div>
  </transition>

</template>

<script>
import TopNavbar from "../components/TopNavbar.vue";
import GlobalRequest from "@/plugins/globalRequest";
import Accordion from "../components/Accordion.vue";
export default {
  name: 'KPDetailPage',
  components: {
    TopNavbar,
    Accordion
  },
  data() {
    return {
      isReady: false,
      loadingItems: false,
      showEditQuantity: 0,
      showEditArea: 0,
      showEditVolume: 0,
      disablecreateBtn: true,
      flagGetItems: false,
      selectedGoods: [],
      errorText: "",
      successText: "",
      errorTextItems: "",
      idGetKP: "",
      data: [],
      addAllItems: [],
      selectedItems: [],
      originOrderAllItems: [],
      selectedRegion:"",
      itogQuantity: 0,
      itogArea: 0,
      itogVolume: 0,
      itogWeight: 0,
      itogSumm: 0,
      objectOrderDraft: {},
      getAddons: false,
      selectDivision: "",
      dublicateItems: []
    }
  },
  async mounted() {
    await this.init()
  },
  watch: {
    'selectedRegion': {
      handler(val) {
        if(val && this.selectedItems.length > 0 && this.selectDivision) 
          this.disablecreateBtn = false
        else 
          this.disablecreateBtn = true
      },
      deep: true
    },
    'selectedItems': {
      handler(val) {
        if(val.length > 0 && this.selectedRegion && this.selectDivision)
          this.disablecreateBtn = false
        else 
          this.disablecreateBtn = true

        if(val.length < this.data.itemsList.length)
          this.addAllItems = []
        else if(val.length > 0 && val.length == this.data.itemsList.length)
          this.addAllItems.push("1")
      },
      deep: true
    },
    // Изменение товаров на разные типы
    'selectDivision': {
      handler(val) {
        this.filterItems()

        if(val && this.selectedItems.length > 0 && this.selectedRegion) 
          this.disablecreateBtn = false
        else 
          this.disablecreateBtn = true

        this.addAllItems = []
        this.selectedItems = []
      },
      deep: true
    },
    'data.itemsList': {
      handler(val) {
        val.forEach(item => {
          let itemDubl = this.dublicateItems.find(itemDubl => itemDubl.id == item.id);
          if(itemDubl) {
            itemDubl.quantity = item.quantity
            itemDubl.area = item.area
            itemDubl.volume = item.volume
            itemDubl.weight = item.weight
          }
        });
        
      },
      deep: true
    },
  },
  methods: {

    async init() {
      this.isReady = false
      this.idGetKP = this.$route.query.id

      await this.getObjOrderDraft()
      if(this.isEmpty(this.objectOrderDraft)) {
        this.errorText = "Данные для предзаполнения не были получены"
      }
      else {
        await this.getObjKP()
        console.log(this.data)
      }

      this.isReady = true
    },

    filterItems() {
      // все товары
      let jsonItems = JSON.stringify(this.dublicateItems) 
      let dubleItems = JSON.parse(jsonItems)

      if(this.selectDivision == "") {
        this.data.itemsList = dubleItems
      }
      else {
        this.data.itemsList = dubleItems.filter(item => item.division === this.selectDivision)
      }

      this.calculateItog()
    },

    async getObjOrderDraft() {
      let res = await GlobalRequest.request("/order/draft", "GET")
      console.log(res)
      if(res.success)
        this.objectOrderDraft = res.data
    },

    async getObjKP() {
      let res = await GlobalRequest.request("/proposal/" + this.idGetKP, "GET")
      console.log(res)
      this.data = res.data
      this.data.validFrom = this.formatDate(this.data.validFrom)
      this.data.validTo = this.formatDate(this.data.validTo)
      
      this.data.itemsList.forEach(item => {
        item.quantity = 1;
      });

      this.calculateItog()

      let jsonItems = JSON.stringify(this.data.itemsList) 
      this.originOrderAllItems = JSON.parse(jsonItems)
      this.dublicateItems = JSON.parse(jsonItems)
    },

    formatDate(dateString) {
      const date = new Date(dateString);
      const day = date.getDate().toString().padStart(2, '0');
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const year = date.getFullYear();
      return `${day}.${month}.${year}`;
    },

    // Выбрать все чекбоксы или очистить 
    selectAllItems() {
      if(this.addAllItems.includes("1")) {
        this.addAllItems = []
        this.selectedItems = []
      }
      else {
        this.addAllItems.push("1")
        this.data.itemsList.forEach(item => {
          this.selectedItems.push(item.id)
        });
      }
    },

    getItogItemSumm(item) {
      let price = parseFloat(item.price).toFixed(2)
      let quantity = parseInt(item.quantity, 10)
      let itogSumm = price * quantity
      item.total = (itogSumm).toFixed(2)
      return (itogSumm).toFixed(2)
    },

    getEditArea(id) {
      if(this.showEditArea == 0 && this.showEditVolume == 0 && this.showEditQuantity == 0) 
        this.showEditArea = id
    },

    getEditVolume(id) {
      if(this.showEditArea == 0 && this.showEditVolume == 0 && this.showEditQuantity == 0) 
        this.showEditVolume = id
    },

    getEditQuantity(id) {
      if(this.showEditArea == 0 && this.showEditVolume == 0 && this.showEditQuantity == 0) 
        this.showEditQuantity = id
    },

    calculateQuantity(item) {
      // округляем на всякий
      item.quantity = Math.round(item.quantity)
      if(item.quantity < 0) item.quantity = 1

      // Получить товар в изначальном виде,как в бд для расчета
      let originItem = this.originOrderAllItems.find(elem => elem.id === item.id);
      let itemArea = parseFloat(originItem.area);     
      let itemVolume = parseFloat(originItem.volume);   
      let itemWeight = parseFloat(originItem.weight);    

      // рассчет area
      item.area = (item.quantity * itemArea).toFixed(2);

      // рассчет volume
      item.volume = (item.quantity * itemVolume).toFixed(2);

      // рассчет weight
      item.weight = (item.quantity * itemWeight).toFixed(2);

      this.showEditQuantity = 0;
      this.calculateItog()
    },

    calculateArea(item) { // m2
      
      // Получить товар в изначальном виде,как в бд для расчета
      let originItem = this.originOrderAllItems.find(elem => elem.id === item.id);
      let itemArea = parseFloat(originItem.area);     
      // После завершения редактирования поля пользователем должно произойти округление 
      // указанного в поле значения до ближайшего числа, кратного (Item.Area)
      if(parseFloat(item.area) < itemArea)
        item.area = itemArea
      else
        item.area = (Math.round(item.area / itemArea) * itemArea).toFixed(2);

      let orderItemArea = parseFloat(item.area);
      let itemVolume = parseFloat(originItem.volume); 
      let itemWeight = parseFloat(originItem.weight); 

      // рассчет quantity  
      item.quantity = Math.round(orderItemArea / itemArea);

      // рассчет volume  
      item.volume = (orderItemArea / itemArea * itemVolume).toFixed(2);

      // рассчет weight
      item.weight = (orderItemArea / itemArea * itemWeight).toFixed(2);

      this.showEditArea = 0
      this.calculateItog()
    },

    calculateVolume(item) { // m3
      // Получить товар в изначальном виде,как в бд для расчета
      let originItem = this.originOrderAllItems.find(elem => elem.id === item.id);
      let itemVolume = parseFloat(originItem.volume);

      // После завершения редактирования поля пользователем должно произойти округление 
      // указанного в поле значения до ближайшего числа, кратного Item.Volume
      if(parseFloat(item.volume) < itemVolume)
        item.volume = itemVolume
      else
        item.volume = (Math.round(item.volume / itemVolume) * itemVolume).toFixed(2);

      let orderItemVolume = parseFloat(item.volume);
      let itemArea = parseFloat(originItem.area);
      let itemWeight = parseFloat(originItem.weight); 

      // рассчет quantity
      item.quantity = Math.round(orderItemVolume / itemVolume);

      // рассчет area
      item.area = (orderItemVolume / itemVolume * itemArea).toFixed(2);

      // рассчет weight
      item.weight = (orderItemVolume / itemVolume * itemWeight).toFixed(2);

      this.showEditVolume = 0
      this.calculateItog()
    },

    calculateItog() {
      this.itogQuantity = 0;
      this.itogArea = 0;
      this.itogVolume = 0;
      this.itogWeight = 0;
      this.itogSumm = 0;
      this.data.itemsList.forEach(item => {
          this.itogQuantity += item.quantity
          this.itogArea += parseFloat(item.area)
          this.itogVolume += parseFloat(item.volume)
          this.itogWeight += parseFloat(item.weight)
          this.itogSumm += parseFloat(item.price)*item.quantity
        });

      this.itogQuantity = parseInt(this.itogQuantity, 10)
      this.itogArea = (this.itogArea).toFixed(2)
      this.itogVolume = (this.itogVolume).toFixed(2)
      this.itogWeight = (this.itogWeight).toFixed(2)
      this.itogSumm = (this.itogSumm).toFixed(2)
    },

    // Скачать pdf
    downloadFile(fileUrl) {
      if(fileUrl) {
        const a = document.createElement('a');
        a.href = fileUrl; // Используем существующий URL
        a.download = fileUrl.split('/').pop(); // Название файла
        document.body.appendChild(a);
        a.click();
        a.remove();
      }
    },

    generateKey(date) {
      return `${date.getTime()}-${this.idGetKP}`;
    },

    isEmpty(data) {
      if(data != "" && data != " " && data != 0 && data != null) {
        if(data.length > 0) return false
      }
      else {
        return true
      }
    },

    // Создать заказ
    createElement() {
      // объект для передачи в заказ
      let objOrder = {}
      objOrder.region = this.selectedRegion;
      objOrder.division = this.data.itemsList[0].division;
      objOrder.items = [];
      this.data.itemsList.forEach(item => {
        if(this.selectedItems.includes(item.id)) {
          let obj = {}
          obj.id = item.id
          obj.quantity = item.quantity
          objOrder.items.push(obj)
        }
      });
      console.log(objOrder)
      console.log(this.generateKey(new Date()))
      const keyKP = this.generateKey(new Date());

      const orderData = objOrder;
      
      this.$store.commit('REMOVE_EXPIRED_ORDER_DATA'); // Очищаем устаревшие данные
      this.$store.commit('SET_ORDER_DATA', { key: keyKP, data: orderData }); // Сохранение в Vuex

      this.$router.push({
        path: '/order/create',
        query: { 
          idKP: this.idGetKP,
          key: keyKP,
        },
      });
    },

    // Отслупы по тысячным в числах
    formatNumber(numberText) {
      if(numberText) {
        return numberText.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
      } 
    },

  }
}
</script>